<template>
  <DocumentFormSection id="option-names" :required="true" :slot-max-width="1400" :show-description="false">
    <template v-if="optionNames.length">
      <OptionNameTranslationEdit
        v-for="(option, index) in optionNames"
        :key="option.option_id"
        :model-value="option.name || ''"
        class="w-full mt-4"
        :offer-title="option.code"
        :commercial-name="curationOptionNames[index]?.name || ''"
        :language="language"
        readonly
      />
    </template>
    <p v-else class="text-sm text-text-80">{{ $t("common.no-content") }}</p>
  </DocumentFormSection>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DocumentFormSection from "@/components/Document/FormSection/FormSection.vue";
import OptionNameTranslationEdit from "@/features/experience-curation/option-names/components/OptionNameTranslationEdit.vue";
import { RevisionFormProps } from "../types/forms";

const { $t } = useNuxtApp();

const props = defineProps<RevisionFormProps & { curationValues?: Record<string, any> | null }>();
const route = useRoute();

const language = computed(() => route.params.language as string);

const optionNames = computed(() => props.values?.optionNames ?? []);

const curationOptionNames = computed(() => props.curationValues?.optionNames ?? []);
</script>
